// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22L5v","content":"styles_content__148v5"};